import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from 'src/app/shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from 'src/app/shared/guard/authentication-guard';
import { Entity } from 'src/app/shared/store/view/types';
import { HasUnsavedChangesGuard } from '../../../shared/guard/has-form-changed.guard';
import { HeaderMenuType } from '../../../shared/store/view/types';
import { CurrencyCreateComponent } from './currency-create/currency-create.component';
import { CurrencyDetailsComponent } from './currency-details/currency-details.component';
import { CurrencyEditComponent } from './currency-edit/currency-edit.component';

const routes: Routes = [
  {
    path: 'Configuration/Currencies',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          entity: Entity.Currency,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: CurrencyDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          entity: Entity.Currency,
          breadcrumb: { label: ' ', alias: 'currencyDetails' },
        },
      },
      {
        path: 'Create',
        component: CurrencyCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          entity: Entity.Currency,
          breadcrumb: { label: ' ', alias: 'currencyCreate' },
        },
      },
      {
        path: 'Edit/:id',
        component: CurrencyEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          entity: Entity.Currency,
          breadcrumb: { label: ' ', alias: 'currencyEdit' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CurrencyRoutingModule {}
